import { Currency } from '@/core/currency/interfaces';

const GTQ: Currency = {
    name: 'Guatemalan Quetzal',
    demonym: 'Guatemalan',
    majorSingle: 'Quetzal',
    majorPlural: 'Quetzales',
    codeNumeric: '320',
    symbol: 'Q',
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'GTQ',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default GTQ;
